import React, { useState } from 'react';
import AuthService from '../services/auth';
import Loader from './Loader';

function Login({ onLogin }) {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [isRegister, setIsRegister] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await AuthService.login(formData.username, formData.password);
      onLogin();
    } catch (error) {
      setError('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-gradient">
      <div className="card shadow-lg border-0" style={{width: '400px', borderRadius: '15px'}}>
        <div className="card-body p-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold text-primary">
              <i className="fas fa-boxes me-2"></i>Saral Asset Manager
            </h2>
            <p className="text-muted">Sign in to your account</p>
          </div>
          
          {error && <div className="alert alert-danger">{error}</div>}
          
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="text"
                className="form-control form-control-lg"
                placeholder="Username"
                value={formData.username}
                onChange={(e) => setFormData({...formData, username: e.target.value})}
                required
                style={{borderRadius: '10px'}}
              />
            </div>
            <div className="mb-4">
              <input
                type="password"
                className="form-control form-control-lg"
                placeholder="Password"
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                required
                style={{borderRadius: '10px'}}
              />
            </div>
            <button 
              type="submit" 
              className={`btn btn-primary btn-lg w-100 mb-3 ${loading ? 'btn-loading' : ''}`}
              style={{borderRadius: '10px'}}
              disabled={loading}
            >
              {loading ? (
                <div className="inline-loader">
                  <Loader size="small" />
                  <span>Signing In...</span>
                </div>
              ) : (
                'Sign In'
              )}
            </button>
          </form>
          

        </div>
      </div>
    </div>
  );
}

export default Login;